// Maps the Abecas profile color flag to a CSS color.
// Legend (single character, digit or letter):
//   Z/0 = None, 1 = Aqua, 2 = Blue, 3 = Fuchsia, 4 = Green, 5 = Lime,
//   6 = Maroon, 7 = Navy, 8 = Olive, 9 = Purple,
//   R = Red, S = Silver, T = Teal, W = White, Y = Yellow.
// Falls back to using the value as-is so a literal CSS color name still works.
export const flagToCssColor = (flag) => {
    if (flag == null) return null;
    const key = String(flag).trim().toUpperCase();
    if (key === '' || key === 'Z' || key === '0') return null;
    const map = {
        '1': '#00ffff', // Aqua
        '2': '#0000ff', // Blue
        '3': '#ff00ff', // Fuchsia
        '4': '#008000', // Green
        '5': '#00ff00', // Lime
        '6': '#800000', // Maroon
        '7': '#000080', // Navy
        '8': '#808000', // Olive
        '9': '#800080', // Purple
        R: '#ff0000',   // Red
        S: '#c0c0c0',   // Silver
        T: '#008080',   // Teal
        W: '#ffffff',   // White
        Y: '#ffff00',   // Yellow
    };
    return map[key] || flag;
};

// Pulls TransTab* settings from a profile DTO. Returns null when no profile.
// useColors=true triggers pending/warning logic; useColors=false (the default
// when no profile or TransTabUseColors != 'Y') triggers the Hold fallback.
export const buildTransTabColoring = (profile) => {
    if (!profile) return null;
    const basisFieldMap = {
        A: 'actualReceivedShippedDateTime',
        B: 'plannedReceivedShippedDateTime',
        C: 'deliveryPickupPlannedDateTime',
        D: 'stagingStartDate',
    };
    const num = (v) => (v != null && v !== '' && !isNaN(Number(v))) ? Number(v) : null;
    return {
        useColors: profile.TransTabUseColors === 'Y',
        basisField: basisFieldMap[profile.TransTabBasisDate] || null,
        pendingLevel: num(profile.TransTabPendingLevel),
        pendingColor: profile.TransTabPendingColor || null,
        warningLevel: num(profile.TransTabWarningLevel),
        warningColor: profile.TransTabWarningColor || null,
    };
};

// Ports the Delphi grdOpenTransactionsBottomCustomDraw decision tree:
//   1) When useColors=true: pick the basis date column, compute hours-until,
//      apply Warning if 0 < hours <= warningLevel,
//      else apply Pending if 0 < hours <= pendingLevel.
//   2) Otherwise: if row.status === 'H', apply the Hold highlight (light yellow).
export const applyTransRowColoring = (rowElement, rowData, coloring) => {
    if (!rowElement || !rowData) return;

    if (coloring && coloring.useColors) {
        const basis = coloring.basisField ? rowData[coloring.basisField] : null;
        if (basis) {
            const hoursRemaining = (new Date(basis).getTime() - Date.now()) / 3_600_000;
            if (hoursRemaining > 0) {
                if (coloring.warningLevel != null && hoursRemaining <= coloring.warningLevel) {
                    const css = flagToCssColor(coloring.warningColor);
                    if (css) rowElement.style.backgroundColor = css;
                    return;
                }
                if (coloring.pendingLevel != null && hoursRemaining <= coloring.pendingLevel) {
                    const css = flagToCssColor(coloring.pendingColor);
                    if (css) rowElement.style.backgroundColor = css;
                    return;
                }
            }
        }
        return;
    }

    // Hold highlight when not using time-based colors
    if (rowData.status === 'H') {
        rowElement.style.backgroundColor = '#fff8e1';
        rowElement.style.color = '#000';
    }
};
